import { render } from "./PresentationEvaluation.vue?vue&type=template&id=2b1e468a"
import script from "./PresentationEvaluation.vue?vue&type=script&lang=js"
export * from "./PresentationEvaluation.vue?vue&type=script&lang=js"

import "./PresentationEvaluation.vue?vue&type=style&index=0&id=2b1e468a&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__